/* tslint:disable:max-line-length */
import classNames from 'classnames';
import React from 'react';
import { IconTypeProps } from '../types';

export const FilterIcon = ({
  className,
  style,
  color = '#3A50F3',
  onClick,
  ...rest
}: IconTypeProps) => {
  return (
    <svg
      className={classNames(className)}
      onClick={onClick}
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      style={style}
      {...rest}
    >
      <g clipPath="url(#clip0)">
        <path
          d="M14.999 0H1.00119C0.112905 0 -0.335282 1.07772 0.294061 1.70709L6 7.41422V13.25C5.99999 13.3925 6.03046 13.5334 6.08936 13.6632C6.14826 13.793 6.23423 13.9087 6.3415 14.0026L8.3415 15.752C8.98019 16.3109 10 15.867 10 14.9995V7.41422L15.7061 1.70709C16.3342 1.079 15.8891 0 14.999 0ZM9 7V15L7 13.25V7L0.999999 1H15L9 7Z"
          fill={color}
        />
      </g>
      <defs>
        <clipPath id="clip0">
          <rect width="16" height="16" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};
